import { f as fetchConfig } from "@theme/utils";
class SubscriptionForm extends HTMLElement {
  connectedCallback() {
    this.planOptions = this.querySelectorAll(".subscription-plan-option");
    this.radios = this.querySelectorAll('input[name="selling_plan"]');
    this.form = this.querySelector("form");
    this.submitButton = this.form?.querySelector('[type="submit"]');
    this.cartDrawer = document.querySelector("cart-drawer");
    this.radios.forEach((radio) => {
      radio.addEventListener("change", () => this.updateSelectedPlan());
    });
    if (this.form) {
      this.form.addEventListener("submit", (e) => this.onSubmit(e));
    }
    this.updateSelectedPlan();
    this.listenForPlanLinks();
  }
  selectPlanByIndex(index) {
    const radio = this.radios[index - 1];
    if (radio) {
      radio.checked = true;
      this.updateSelectedPlan();
    }
  }
  listenForPlanLinks() {
    document.querySelectorAll("[data-select-plan]").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const planIndex = parseInt(link.getAttribute("data-select-plan"), 10);
        this.selectPlanByIndex(planIndex);
        this.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  }
  updateSelectedPlan() {
    this.planOptions.forEach((label) => {
      const radio = label.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        label.style.borderWidth = "4px";
      } else {
        label.style.borderWidth = "1px";
      }
    });
  }
  onSubmit(evt) {
    evt.preventDefault();
    if (!this.submitButton || this.submitButton.hasAttribute("disabled") || this.submitButton.getAttribute("aria-disabled") === "true") {
      return;
    }
    this.submitButton.setAttribute("aria-disabled", "true");
    const btnText = this.submitButton.querySelector(".btn-text");
    const btnSpinner = this.submitButton.querySelector(".btn-spinner");
    if (btnText) btnText.style.opacity = "0";
    if (btnSpinner) btnSpinner.style.opacity = "1";
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(this.form);
    if (this.cartDrawer) {
      formData.append(
        "sections",
        this.cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cartDrawer.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(window.routes.cart_add_url, config).then((response) => response.json()).then((response) => {
      if (response.status) {
        this.handleError(response.description);
        return;
      }
      if (this.cartDrawer) {
        this.cartDrawer.renderContents(response);
        if (this.cartDrawer.classList.contains("is-empty")) {
          this.cartDrawer.classList.remove("is-empty");
        }
      } else {
        window.location = window.routes.cart_url;
      }
    }).catch((error) => {
      console.error("Subscription add to cart error:", error);
      this.handleError("An error occurred. Please try again.");
    }).finally(() => {
      this.submitButton.removeAttribute("aria-disabled");
      const btnText2 = this.submitButton.querySelector(".btn-text");
      const btnSpinner2 = this.submitButton.querySelector(".btn-spinner");
      if (btnText2) btnText2.style.opacity = "1";
      if (btnSpinner2) btnSpinner2.style.opacity = "0";
    });
  }
  handleError(message) {
    const errorElement = this.querySelector("[data-error-message]");
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove("hidden");
      setTimeout(() => errorElement.classList.add("hidden"), 3e3);
    } else {
      alert(message);
    }
  }
}
customElements.define("subscription-form", SubscriptionForm);
